import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import axios from "axios";
import useApiNew from "../../../utils/useApiNew";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDate from "./date/CustomDate";
import CustomDate1 from "./date/CustomDate1";
import CustomDate2 from "./date/CustomDate2";
import { is } from "date-fns/locale";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const scriptApiURL = `${process.env.REACT_APP_API_URL}api/script`;
const securityTypeURLApi = `${process.env.REACT_APP_API_URL}api/security-type`;

const CorporateActionMasterAdd = ({
  buttonConfig,
  renderKey,
  isButtonClicked,
}) => {
  const addHandler = buttonConfig.addHandler;
  const closeHandler = buttonConfig.closeAddModal;

  const [HandleSetValue, setHandleSetValue] = useState("");
  const [handleInput, setHandleInput] = useState({});
  const [scriptData, setScriptData] = useState([]);
  const [isin, setIsin] = useState("");
  const [securityType, setSecurityType] = useState("");
  const [faceValue, setFaceValue] = useState("");
  const [scriptName, setScriptName] = useState("");
  const [secIsin, setSecIsin] = useState("");
  const [secSecurityType, setSecSecurityType] = useState("");
  const [secFaceValue, setSecFaceValue] = useState("");
  const [secScriptName, setSecScriptName] = useState("");

  const autoFillData = {
    isin: isin,
    security_type: secSecurityType ? secSecurityType : securityType,
    face_value: secFaceValue ? secFaceValue : faceValue,
    script_name: scriptName,
  };

  const autoFillData1 = {
    isin_sec: secIsin,
  };

  const objdata = {
    status: true,
    file_tag: "VSFT",
    action_code: "A",
    caa_status: "P",
    corpaction_tag: "",
    bookclose_recorddate: "",
    bse_exdate: "",
    nse_exdate: "",
    price: "",
    multiplier: "",
    secondary_security_type: "",
    secondary_face_value: "",
    secondary_company_name: "",
    inputile_id: "",
    remarks: "",
    ...handleInput,
    ...HandleSetValue,
    ...autoFillData,
    ...autoFillData1,
  };

  // form.setValue("isin_sec", isin);
  // form.setValue("secondary_security_type", securityType);
  // form.setValue("secondary_face_value", faceValue);
  // form.setValue("secondary_company_name", scrt);

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
      "Content-Type": "application/json",
    }),
    [],
  );

  const src = useMemo(
    () => async () => {
      try {
        const res = await axios.get(scriptApiURL, { headers });
        console.log(res, "add dsjdsh");
        setScriptData(res.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    [headers, scriptApiURL],
  );

  const { data: securityData } = useApiNew(securityTypeURLApi, "GET", {
    headers,
  });

  useEffect(() => {
    src();
  }, [src]);

  const schema = z.object({
    // file_tag: z.string(),
    // action_code: z.string(),
    // inputile_id: z.string(),
    // isin: z.string().nonempty(),
    // isin_sec: z.string(),
    // bookclose_recorddate: z.string(),
    // bse_exdate: z.string(),
    // nse_exdate: z.string(),
    // corpaction_tag: z.string(),
    // price: z.string(),
    // multiplier: z.string(),
    // company_name: z.string(),
    // security_type: z.string(),
    // face_value: z.string(),
    // remarks: z.string(),
  });

  const form = useForm({
    defaultValues: {},
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const handleChange = (e) => {
    setHandleInput((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSelect = (e) => {
    const [scrt, isin, securityType, faceValue] = e.target.value.split("_");
    setIsin(isin);
    setSecurityType(securityType);
    setFaceValue(faceValue);
    setScriptName(scrt);
  };

  const handleOnSelect1 = (e) => {
    const [scrt, isin, securityType, faceValue] = e.target.value.split("_");
    setSecIsin(isin);
    setSecSecurityType(securityType);
    setSecFaceValue(faceValue);
    setSecScriptName(scrt);
    form.setValue("isin_sec", isin);
    form.setValue("secondary_security_type", securityType);
    form.setValue("secondary_face_value", faceValue);
    form.setValue("secondary_company_name", scrt);
  };

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      ...objdata,
      company_name: scriptName || "",
      isin_sec: form.getValues("isin_sec") || "",
      secondary_security_type: form.getValues("secondary_security_type") || "",
      secondary_face_value: form.getValues("secondary_face_value") || "",
      secondary_company_name: form.getValues("secondary_company_name") || "",
    };
    console.log(updatedData);
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 top-[57%] z-50 mx-auto w-[98%] max-w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8 max-lg:max-h-[800px] lg:max-h-[600px]">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Add Corporate Action{" "}
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="scrollbar-custom w-full overflow-y-scroll pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}

            <div className="w-full items-baseline gap-2 lg:flex ">
              <div className="w-full items-baseline gap-2 sm:flex ">
                <div
                  className={
                    " flex w-full flex-col items-stretch gap-2 text-neutral-600"
                  }
                >
                  <label className="block text-base text-[#636363]">
                    Scrip name
                  </label>
                  <select
                    name="script_name"
                    onChange={handleOnSelect}
                    className={cn(
                      "block h-full w-[100%] rounded bg-neutral-100 px-2  py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                      errors.purpose && "border-[1px] border-red-300",
                    )}
                  >
                    <option value="">Select</option>
                    {scriptData &&
                      scriptData.map((item, index) => (
                        <option
                          value={`${item?.script_name}_${item.isin}_${
                            item?.script_type_name
                          }_${
                            item?.nse_face_value
                              ? item?.nse_face_value
                              : item?.bse_face_value
                          }`}
                          key={index}
                        >
                          {item?.script_name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>ISIN</label>

                    <div className="relative flex w-full">
                      <input
                        onChange={handleChange}
                        placeholder="Enter here"
                        value={isin}
                        name="isin"
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none",
                          errors.record_date && "border-[1px] border-red-300",
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-baseline gap-2 max-lg:mt-4 sm:flex">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    Corporate Action
                  </label>
                  <select
                    onChange={handleChange}
                    name="corpaction_tag"
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                      errors.security_code && "border-[1px] border-red-300",
                    )}
                  >
                    <option className="">Select</option>
                    <option value="B" className="">
                      Bonus
                    </option>
                    <option value="S" className="">
                      Split
                    </option>
                    <option value="R" className="">
                      Reduction
                    </option>
                    <option value="C" className="">
                      Consolidation
                    </option>
                    <option value="A" className="">
                      Merger
                    </option>
                    <option value="X" className="">
                      Demerger
                    </option>
                    <option value="D" className="">
                      Dividend
                    </option>
                    <option value="G" className="">
                      Right
                    </option>
                  </select>
                </div>
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Corp. Action Status</label>
                    <select
                      onChange={handleChange}
                      disabled
                      name="caa_status"
                      defaultValue="P"
                      className={cn(
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                        errors.caa_status && "border-[1px] border-red-300",
                      )}
                    >
                      <option value="P">Pending</option>
                      <option value="A">Approved</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>BC / Record Date</label>

                    <div className="relative flex w-full">
                      <CustomDate setHandleSetValue={setHandleSetValue} />
                    </div>
                  </div>
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>NSE EX Date</label>

                    <div className="relative flex w-full">
                      <CustomDate1 setHandleSetValue={setHandleSetValue} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>BSE Ex Date</label>

                    <div className="relative flex w-full">
                      <CustomDate2 setHandleSetValue={setHandleSetValue} />
                    </div>
                  </div>
                </div>
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Dividend / Rights Price</label>

                    <div className="relative flex w-full">
                      <input
                        onChange={handleChange}
                        name="price"
                        placeholder="Enter here"
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none",
                          errors.bc_end_date && "border-[1px] border-red-300",
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* row 3 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 sm:flex ">
                <div className={"flex w-full flex-col  gap-2"}>
                  <label className="text-base text-[#636363]">Multiplier</label>
                  <input
                    onChange={handleChange}
                    name="multiplier"
                    placeholder="Enter here"
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                      "border-[1px] ",
                    )}
                  />
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Security Type</label>

                    <select
                      name="security_type"
                      onChange={handleChange}
                      // value={securityType}
                      className={cn(
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                        errors.security_code && "border-[1px] border-red-300",
                      )}
                    >
                      <option value="">Select</option>
                      {securityData &&
                        securityData.map((item, index) => (
                          <option value={`${item?.short_name}`} key={index}>
                            {item?.security_type}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Face Value</label>

                    <div className="relative flex w-full">
                      <input
                        onChange={handleChange}
                        placeholder="Enter here"
                        name="fc_value"
                        value={faceValue}
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none",
                          errors.bc_end_date && "border-[1px] border-red-300",
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn("op flex w-full flex-col gap-2")}></div>
              </div>
            </div>

            {/* row 4 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 sm:flex  ">
                <div
                  className={
                    " flex w-full flex-col items-stretch gap-2 text-neutral-600"
                  }
                >
                  <label className="block text-base text-[#636363]">
                    Secondary Scrip name
                  </label>
                  <select
                    name="secondary_company_name"
                    onChange={handleOnSelect1}
                    disabled={["B", "S", "C", "D", "G"].includes(
                      handleInput.corpaction_tag,
                    )}
                    className={cn(
                      "block h-full w-[100%] rounded bg-neutral-100 px-2  py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                      errors.secondary_company_name &&
                        "border-[1px] border-red-300",
                    )}
                  >
                    <option value="">Select</option>
                    {scriptData &&
                      scriptData.map((item, index) => (
                        <option
                          value={`${item?.script_name}_${item.isin}_${
                            item?.script_type_name
                          }_${
                            item?.nse_face_value
                              ? item?.nse_face_value
                              : item?.bse_face_value
                          }`}
                          key={index}
                        >
                          {item?.script_name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Secondary ISIN</label>

                    <div className="relative flex w-full">
                      <input
                        placeholder="Enter here"
                        disabled={["B", "S", "C", "D", "G"].includes(
                          handleInput.corpaction_tag,
                        )}
                        value={secIsin}
                        name="isin_sec"
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none",
                          errors.isin_sec && "border-[1px] border-red-300",
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex  ">
                <div className=" w-full items-stretch gap-4 text-neutral-600 sm:flex">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Secondary Security Type</label>
                    <input
                      name="secondary_security_type"
                      placeholder="Enter here"
                      value={secSecurityType}
                      disabled={["B", "S", "C", "D", "G"].includes(
                        handleInput.corpaction_tag,
                      )}
                      className={cn(
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none",
                        errors.secondary_security_type &&
                          "border-[1px] border-red-300",
                      )}
                    />
                  </div>
                  <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                    <div className="flex w-full  flex-col gap-2 ">
                      <label>Secondary Face Value</label>
                      <div className="relative flex w-full">
                        <input
                          disabled={["B", "S", "C", "D", "G"].includes(
                            handleInput.corpaction_tag,
                          )}
                          value={secFaceValue}
                          placeholder="Enter here"
                          name="secondary_face_value"
                          className={cn(
                            "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none",
                            errors.secondary_face_value &&
                              "border-[1px] border-red-300",
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-neutral-600 max-sm:mt-4">
              <label>Remarks</label>
              <textarea
                name="remarks"
                onChange={handleChange}
                rows={3}
                cols={50}
                className=" w-full rounded-[5px] bg-neutral-100 text-[#636363]"
              />
            </div>
          </div>

          <div className="mt-8 flex items-end max-sm:justify-center md:justify-between max-lg:[&>button]:w-[50%] max-sm:[&>button]:w-full lg:[&>button]:w-1/4">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-7 py-2 font-semibold text-white`}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
            <button className="max-md:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default CorporateActionMasterAdd;
